import * as React from "react";
import { Tab, Header, Grid, Container } from "semantic-ui-react";

import { CaseType } from "@teamprevent/common/model";
import { MessagingModalButton } from "@teamprevent/common/messaging/components/MessagingModalButton";

import { Authorize } from "reauthorize";

import { loadOhCaseDetail } from "../../actions";

import { CoreDetailProps, DetailProps } from "../Detail";
import CancelButton from "../CancelButton";
import { ReferAgainButton } from "../referAgain/ReferAgainButton";
import { ReferAgainPaths } from "../referAgain/referAgainRoutes";
import { ManageAssignedUsersButton } from "../manageAssignedUsers/ManageAssignedUsersButton";
import { ManageAssignedUsersPaths } from "../manageAssignedUsers/manageAssignedUsersRoutes";
import { CUSTOMER_ROLES, isCaseManager } from "../../../../auth/model";

import { CoreDetailsButtons } from "./CoreDetailButtons";
import { OhCaseTimeline } from "./OhCaseTimeline";
import { WorkAdjustmentCaseDetails } from "./workAdjustment/WorkAdjustmentCaseDetails";

export const CoreDetails: React.SFC<CoreDetailProps> = (props) => {
    const isReferralCase = props.ohCase.caseType === CaseType.REFERRAL;
    const isNotWorkAdjustmentCase = props.ohCase.caseType !== CaseType.WORK_ADJUSTMENT;
    const isNotCancelled = props.ohCase.caseStatus !== "Cancelled";

    return (
        <>
            <Grid className="case-summary-grid">
                <Grid.Row>
                    <Grid.Column>
                        <Header as="h1">Case Summary - {props.ohCase.caseId}</Header>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column className="primary-column" width={6}>
                        Name
                    </Grid.Column>
                    <Grid.Column width={8}>
                        {props.ohCase.employeeFirstName} {props.ohCase.employeeLastName}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column className="primary-column" width={6}>
                        Date of Birth
                    </Grid.Column>
                    <Grid.Column width={8}>
                        {props.ohCase.dateOfBirth && props.ohCase.dateOfBirth.format("DD/MM/YYYY")}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column className="primary-column" width={6}>
                        Position
                    </Grid.Column>
                    <Grid.Column width={8}>
                        {props.ohCase.jobTitle}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="case-summary-actions">
                    <Grid.Column computer={8} tablet={8} mobile={16}>
                        {props.ohCase.id &&
                            <Authorize
                                authorize={[
                                    CUSTOMER_ROLES.manager.name,
                                    CUSTOMER_ROLES.hr.name,
                                    CUSTOMER_ROLES.recruitmentManager.name,
                                    CUSTOMER_ROLES.caseManager.name,
                                    CUSTOMER_ROLES.customerAdministrator.name
                                ]}>
                                <MessagingModalButton
                                    action={() => loadOhCaseDetail({ ohCaseId: props.ohCase?.id, forceLoad: true })}
                                    customerId={props.currentCustomer?.id}
                                    caseId={props.ohCase?.id}
                                    buttonText={"Contact OH about this case"} />
                            </Authorize>
                        }
                        {isReferralCase && <ReferAgainButton referCaseAgainSubpath={ReferAgainPaths.Referral} />}
                        {isCaseManager(props.currentUser) &&
                            <ManageAssignedUsersButton manageAssignedUsersSubpath={ManageAssignedUsersPaths.ManageAssignedUsersRoute} />}
                    </Grid.Column>
                    <Grid.Column computer={8} tablet={8} mobile={16} floated="right" textAlign="right">
                        {isNotWorkAdjustmentCase && isNotCancelled && <CancelButton ohCase={props.ohCase} redirectUrl="/ohCases" />}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {props.ohCase?.caseType === CaseType.WORK_ADJUSTMENT && <WorkAdjustmentCaseDetails workAdjustmentCaseId={props.ohCase?.id} />}
            <Grid className="case-timeline-grid">
                <Grid.Row className="case-timeline-header">
                    <Grid.Column mobile={8} computer={4}>Case</Grid.Column>
                    <Grid.Column mobile={8} computer={12}>Status</Grid.Column>
                </Grid.Row>
                <OhCaseTimeline ohCase={props.ohCase} />
            </Grid>
        </>
    );
};

export const CoreDetailsWithActions: React.FunctionComponent<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails ohCase={props.ohCase} currentCustomer={props.currentCustomer} currentUser={props.currentUser} />
            <Container className="case-actions">
                <CoreDetailsButtons ohCase={props.ohCase} currentCustomer={props.currentCustomer} currentUser={props.currentUser} />
            </Container>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    authorise: true,
    render: () => <Tab.Pane className="details-tab-pane"><CoreDetailsWithActions {...props} /></Tab.Pane>
});
